import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/landing/Logo";
import { Footer } from "@/components/landing/Footer";

export default function LegalPage({ eyebrow, title, version, effectiveDate, children, testId }) {
  return (
    <div className="min-h-screen bg-white text-brand-slate flex flex-col" data-testid={testId}>
      <header className="border-b border-brand-navy/10">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between">
          <Link to="/" aria-label="Back to home" data-testid="legal-home-link">
            <Logo tone="dark" size="sm" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-brand-navy/60 hover:text-brand-orange transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={14} strokeWidth={1.5} />
            Back to site
          </Link>
        </div>
      </header>

      <main className="flex-1 py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <p
            className="text-[11px] md:text-[13px] uppercase tracking-[0.45em] text-brand-navy/50 mb-4"
            data-testid="legal-eyebrow"
          >
            {eyebrow}
          </p>
          <h1
            className="font-poppins font-semibold text-brand-navy text-3xl md:text-5xl tracking-tight leading-tight"
            data-testid="legal-title"
          >
            {title}
          </h1>
          {(version || effectiveDate) && (
            <div className="mt-4 flex flex-wrap gap-x-6 gap-y-1 text-sm text-brand-slate/60" data-testid="legal-meta">
              {version && <span>Version {version}</span>}
              {effectiveDate && <span>Effective Date: {effectiveDate}</span>}
            </div>
          )}

          <div className="mt-12 md:mt-16 space-y-10 text-[15px] md:text-base leading-relaxed text-brand-slate/85" data-testid="legal-body">
            {children}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export function Section({ number, title, children }) {
  return (
    <section className="space-y-4">
      <h2 className="font-poppins font-semibold text-brand-navy text-xl md:text-2xl tracking-tight">
        {number}. {title}
      </h2>
      <div className="space-y-4">{children}</div>
    </section>
  );
}

export function SubSection({ number, title, children }) {
  return (
    <div className="space-y-3 pt-2">
      <h3 className="font-poppins font-semibold text-brand-navy text-base md:text-lg tracking-tight">
        {number} {title}
      </h3>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

export function LegalList({ children }) {
  return (
    <ul className="list-disc pl-6 space-y-1.5 marker:text-brand-orange/70">
      {children}
    </ul>
  );
}
